export const makeEdgeConfigurationLink = (clusterId: string) =>
  `/automation/external-clusters/${clusterId}/autoscaler/settings/edge-configuration`;
